<ngx-panel>
	<panel-heading>
		<div class="title ellipsis">
			<span translate="activity-editor-source-media-panel-header"></span>
		</div>
		<ngx-toolbar>
			<ngx-toolbar-button
				[action]="Action.EDIT"
				(clicked)="openMediaPreviewModal(true)">
			</ngx-toolbar-button>

			<ngx-toolbar-button
				[action]="Action.REMOVE"
				(clicked)="onRemove.emit()">
			</ngx-toolbar-button>
		</ngx-toolbar>
	</panel-heading>
	<panel-body>
		<div class="source-media">
            <ngx-media-thumbnail
                class="source-media-thumbnail"
				[media]="sourceMedia.media"
			></ngx-media-thumbnail>

			<span
				class="source-media-title"
				(click)="openMediaPreviewModal(false)">
				{{sourceMedia.media.title || 'common_untitled' | translate}}
			</span>
		</div>
	</panel-body>
</ngx-panel>
